/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Restricted_AccessInputs */



/**
* | output |
* | --- |
* | "Restricted Access" |
*
* @param {Knp_Guide_Restricted_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_restricted_access = /** @type {((inputs?: Knp_Guide_Restricted_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Restricted_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accès restreint")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschränkter Zugriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso limitato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ограниченный доступ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acceso restringido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("受限访问")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクセス制限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिबंधित पहुंच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Acesso restrito")
	return /** @type {LocalizedString} */ ("Restricted Access")
});